import React, {useEffect, useState} from 'react'
import AppDialog from "../dialog/appdialog";
import {DOWNLOAD_SUB_TITLE, DOWNLOAD_TITLE, OK, PROCEED, USER} from "../../constants/appconstants";
import {clrPreSignURLService} from "@app/common/services/clrpresignurlservice";
import get from "lodash/get";
import {clrDownloadFileService} from "@app/common/services/clrdownloadbanfileservice";
import moment from "moment";
import fileDownload from "js-file-download";
import {logoutService} from "@app/common/services/logoutservice";
import {bindActionCreators, compose} from "redux";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {setLoading} from "@app/common/store/action";

function BANDownload(props){
    const startDownload= props.startDownload;
    const type=props.type;
    console.log(" customeFunc BANDownload",props)
    const [showDialog,setShowDialog] = useState(false)
    const [isTwoButtons,setIsTwoButtons] = useState(true)
    const [title,setTitle] = useState(DOWNLOAD_TITLE)
    const [subTitle,setSubTitle] = useState(DOWNLOAD_SUB_TITLE)
    console.log("customeFunc startDownload",startDownload)
    useEffect(()=>{
        if(startDownload){
            setIsTwoButtons(true)
            setTitle(DOWNLOAD_TITLE)
            setSubTitle(DOWNLOAD_SUB_TITLE)
            setShowDialog(true)
        }
    },[props.startDownload])

    const dialogCloseHandler = ()=>{
        setShowDialog(false)
        if(props.closeHandler){
            props.closeHandler()
        }
    }

    const downloadFile = async ()=>{
        console.log("downloadFile")
        const { actions } = props;

        if(!isTwoButtons ){
            dialogCloseHandler();
            return
        }

        actions.setLoading(true)
        try{
            let response  = await clrPreSignURLService()
            if (response) {
                let url = get(response,"url")
                let file = await clrDownloadFileService(url)
                console.log("url",url)
                console.log("file",file)
                const todayDate = moment().format("DDMMYYYY");
                fileDownload(file,"User Ban List_"+todayDate+".csv")
            }
            setShowDialog(false)
            if(type!==USER) {
                await logoutService()
            }
            actions.setLoading(false)
            closeHandler()
        }catch(err){
            actions.setLoading(false)
            // this.setState({
            //     showDialog:true,
            //     isTwoButtons:false,
            //     title:DOWNLOAD_TITLE,
            //     subTitle:err,
            // })
            setShowDialog(true)
            setIsTwoButtons(false)
            setTitle(DOWNLOAD_TITLE)
            closeHandler()
            setSubTitle(err)
            console.log(err)
        }
    }
    const closeHandler = ()=>{
        if(props.closeHandler){
            props.closeHandler()
        }
    }
    return(
        <AppDialog isOpen={showDialog} title={title} text={subTitle}
                   requestCloseHandler={dialogCloseHandler}
                   requestActionHandler={downloadFile}
                   rightButtonText={isTwoButtons?PROCEED:OK}
                   isTwoButtons={isTwoButtons}
        />
    )
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {  setLoading},
            dispatch
        ),
    };
}
export default compose(connect(null, mapDispatchToProps),withRouter)(BANDownload);